import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import PaymentProcessing from '.';
import EditGateway from './gateway/Edit';
import AddGateway from './gateway/Add';
import LightspeedPayments from './gateway/LightspeedPayments';

const paths = {
  paymentProcessing: '/settings/payment-processing',
  editGateway: '/settings/payment-processing/edit-gateway/:gatewayId',
  addGateway: '/settings/payment-processing/add-gateway',
  lightspeedPaymentsConfiguration: '/settings/lightspeed-payments/configuration',
};

export default [
  <RouteIfRights
    exact
    path={paths.paymentProcessing}
    key={paths.paymentProcessing}
    component={PaymentProcessing}
    rights="admin"
  />,
  <RouteIfRights
    exact
    path={paths.editGateway}
    key={paths.editGateway}
    component={EditGateway}
    rights="admin"
  />,
  <RouteIfRights
    exact
    path={paths.addGateway}
    key={paths.addGateway}
    component={AddGateway}
    rights="admin"
  />,
  <RouteIfRights
    exact
    path={paths.lightspeedPaymentsConfiguration}
    key={paths.lightspeedPaymentsConfiguration}
    component={LightspeedPayments}
    rights="admin"
  />,
];

export { paths };
